import {produce} from "immer";
import {createReducer} from "typesafe-actions";
import {StoreState, initialState} from "./StoreState";
import {ActionStrong, Actions} from "./Actions";



const reducer = createReducer<StoreState, ActionStrong>(initialState)
	.handleAction(Actions.setAuthInfoAction, (state, action) =>
		produce(state, draft => {
			draft.authInfo = action.payload;
		})
	)



	.handleAction(Actions.setSelectedSearchDictionaryGroups, (state, action) =>
		produce(state, draft => {
			draft.selectedSearchDictionaryGroups = action.payload;
		})
	)



	.handleAction(Actions.setIndexWordsAction, (state, action) =>
		produce(state, draft => {
			for (let i = 0; i < action.payload.stopIndex - action.payload.startIndex + 1; i++) {
				draft.indexWords[action.payload.startIndex + i] = action.payload.loadedIndexWords[i];
			}
		})
	)

	.handleAction(Actions.setIndexWordsCountAction, (state, action) =>
		produce(state, draft => {
			draft.indexWordsCount = action.payload;
		})
	)

	.handleAction(Actions.addIndexWordAction, (state, action) =>
		produce(state, draft => {
			draft.indexWordsCount = 0;
			draft.indexWords = {};

			setTimeout(() => {
				const l = window.document.getElementsByClassName("index_word_list")[0];
				l.scrollTop += 50;
			}, 500);
		})
	)

	.handleAction(Actions.updateIndexWordAction, (state, action) =>
		produce(state, draft => {
			draft.indexWordsCount = 0;
			draft.indexWords = {};

			setTimeout(() => {
				const l = window.document.getElementsByClassName("index_word_list")[0];
				l.scrollTop += 50;
			}, 500);
		})
	)

	.handleAction(Actions.deleteIndexWordAction, (state, action) =>
		produce(state, draft => {
			draft.indexWordsCount = 0;
			draft.indexWords = {};

			setTimeout(() => {
				const l = window.document.getElementsByClassName("index_word_list")[0];
				l.scrollTop += 50;
			}, 500);
		})
	)

	.handleAction(Actions.checkDeleteIndexWordAction, (state, action) =>
		produce(state, draft => {
			const indexWordToCheckDelete = draft.indexWords[action.payload.indexWordIndex];
			indexWordToCheckDelete.deleteChecked = action.payload.deleteChecked;
		})
	)

	.handleAction(Actions.deleteDeleteCheckedIndexWordsAction, (state, action) =>
		produce(state, draft => {
			draft.indexWordsCount = 0;
			draft.indexWords = {};

			setTimeout(() => {
				const l = window.document.getElementsByClassName("index_word_list")[0];
				l.scrollTop += 50;
			}, 500);
		})
	);



export default reducer;